import { render, staticRenderFns } from "./LoginPrueba.vue?vue&type=template&id=e1beca4a&"
import script from "./LoginPrueba.vue?vue&type=script&lang=js&"
export * from "./LoginPrueba.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports